import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "./redux/redux-hooks";
import { DEBUG_SOCKET } from "./config/constants";
import {
  setEventSocketConnected,
  setFancySocketConnected,
  setOddsSocketConnected,
  setSportSocketConnected,
  setUserSocketConnected,
} from "./redux/reducers/socketSlice";
import userSocket from "./sockets/userSocket";
import socketServices from "./sockets/socketService";
import eventSocket from "./sockets/eventSocket";
import sportSocket from "./sockets/sportSocket";
import fancySocketServices from "./sockets/fancySocketServices";
import useReConnectOnTabChange from "./hooks/useReconnectOnTabChange";

const RealSocketInitialization = () => {
  const { isLoggedIn, userData } = useAppSelector((state) => state.user);
  const { userSocketConnected, ...rest } = useAppSelector((state) => state.socket);
  if (DEBUG_SOCKET) console.table({ userSocketConnected, ...rest });
  const dispatch = useAppDispatch();

  // -------------------------------------------------------
  const handleOddsConnection = (connected: boolean) => {
    dispatch(setOddsSocketConnected(connected));
  };
  const handleUserConnection = (connected: boolean) => {
    if (connected) {
      userSocket.joinUser();
    }
    dispatch(setUserSocketConnected(connected));
  };

  // -------------------------------------------------------

  const handleEventConnection = (connected: boolean) => {
    if (connected) {
      dispatch(setEventSocketConnected(connected));
    } else {
      dispatch(setEventSocketConnected(false));
    }
  };

  const handleSportConnection = (connected: boolean) => {
    if (connected) {
      dispatch(setSportSocketConnected(connected));
    } else {
      dispatch(setSportSocketConnected(false));
    }
  };
  const handleFancyConnection = (connected: boolean) => {
    if (connected) {
      dispatch(setFancySocketConnected(connected));
    } else {
      dispatch(setFancySocketConnected(false));
    }
  };

  // -------------------------------------------------------

  const handleConnect = () => {
    if (isLoggedIn && userData?.user_id) {
      console.log("Connect All Socket");
      socketServices.connect((connected: boolean) => {
        handleOddsConnection(connected);

        if (connected) {
          userSocket.connect(handleUserConnection);

          eventSocket.connect(handleEventConnection);
          sportSocket.connect(handleSportConnection);
        }
      });
      fancySocketServices.connect(handleFancyConnection);
    }
  };

  useEffect(() => {
    handleConnect();
  }, [isLoggedIn && userData?.user_id]);

  useReConnectOnTabChange({ handleConnect });

  return null;
};

const SocketInitialization = () => {
  const { isLoggedIn } = useAppSelector((state) => state.user);

  return isLoggedIn ? <RealSocketInitialization /> : null;
};

export default SocketInitialization;
